import $ from 'jquery';

var chats = [];
function addNewHTMLToChat(html, id, $target) {
  if (typeof $target === 'undefined') {
    $target = $('.chat-container');
  }
  var $chat = $('<div class="chat chat-log__item"></div>');
  $chat.attr('id', id);
  $chat.html(html);
  $target.append($chat);
  chats.push({
    id: id,
    richChat: true,
    html: $target
  });
}
window.addNewHTMLToChat = addNewHTMLToChat;

function addMessageToChat(html, id) {
  var $chatContainer = $('#chat-container');
  var $chat = $('<div class="chat chat-log__item"></div>');
  $chat.attr('id', id);
  $chat.html(html);
  $chatContainer.append($chat);
  chats.push({
    id: id,
    richChat: false,
    html: $chatContainer
  });
}
window.addMessageToChat = addMessageToChat;
// $(document).ready(function() {
//   var $chatContainer = $('#chat-container');?
//
// })

$(document).on('click', '.panel-hide-button', function togglePanel(e) {
  e.preventDefault();
  var $header = $(this).closest('.chat-header');
  $header.find('.chat-edit-container').toggle();
  $header.find('.askfelixformeditchat').toggle();

  var $icon = $(this);
  var iconVal = $icon.text().trim();
  $icon.text(iconVal === 'expand_more' ? 'expand_less' : 'expand_more');
});

// todo show buttons on hover
// $(document).on('hover', '.chat-log__item--own', function showDeleteButtons(e) {
//
// }
